"use client";

import { aboutCircleImg, animationEffect, dotsAnimation } from "@/assets/imgs";

import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";

type Props = {
  className: string;
};

const AboutContent = ({ className }: Props) => {
  const t = useTranslations();
  return (
    <div
      className={`${className} flex flex-col items-center gap-20 overflow-hidden bg-lightGrey lg:flex-row`}
    >
      <Image
        alt="circle image"
        src={aboutCircleImg}
        className="z-30 max-w-xs lg:max-w-sm xl:max-w-full"
      />
      <div className="absolute">
   <Image
  alt="animation effect"
  src={animationEffect}
  className="relative w-56 animate-slow-bounce animate-iteration-infinite animate-ease-linear lg:w-64 xl:top-6 xl:w-64  rtl:lg:-bottom-20 rtl:lg:right-14"
/>
      </div>
      <div className="relative flex flex-col justify-center gap-4 pb-20">
        <p className="w-fit rounded-full bg-lightBlue px-7 py-2 text-sm uppercase rtl:text-base rtl:font-semibold">
          {t("links.aboutUs")}
        </p>
        <div className="flex flex-col gap-8 text-lg">
          <h3 className="text-4xl font-bold leading-snug">
            {t("aboutPage.WeAreIncreasing")}
          </h3>
          <div>{t("aboutPage.contentOne")}</div>
          <div>{t("aboutPage.contentTwo")}</div>
          <Link
            href="/contact-us"
            className="w-fit rounded-full border border-black bg-white px-9 py-3 font-semibold text-secondary transition-all duration-200 hover:bg-linear-to-r hover:from-primary hover:from-10% hover:to-secondary hover:text-white"
          >
            {t("links.contactUs")}
          </Link>
        </div>
        <Image
          alt="dots"
          src={dotsAnimation}
          className="absolute w-28 animate-bounce animate-direction-alternate animate-duration-3000 animate-iteration-infinite animate-ease-linear ltr:-top-24 ltr:left-52 ltr:lg:-left-52 ltr:lg:top-3/4 rtl:-top-40 rtl:left-1/2 rtl:lg:-right-40 rtl:lg:top-96 rtl:xl:-right-52 rtl:xl:bottom-0"
        /> 
      </div>
    </div>
  );
};

export default AboutContent;
